import {
  MinusSquareOutlined,
  PlusSquareOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { Tag } from "antd";
import React, { useState } from "react";
import TopPlanElement from "./TopPlanElement";

function ParentPlanGroup(props) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="mb-3">
      {/* Parent Plan Header - Simple row */}
      <div className="flex items-center mb-2 cursor-pointer hover:bg-gray-50 p-2 rounded">
        <div className="flex items-center gap-2 flex-1" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? (
            <PlusSquareOutlined className="text-base" />
          ) : (
            <MinusSquareOutlined className="text-base" />
          )}
          <ClusterOutlined className="text-blue-500" />
          <span className="font-bold">{props.parentPlan.title}</span>
          <Tag color="blue" className="text-xs">
            {props.childPlans.length} {props.childPlans.length === 1 ? "plan" : "plans"}
          </Tag>
        </div>
      </div>

      {/* Child Plans - Indented */}
      {!collapsed && (
        <div className="ml-6 space-y-2">
          {props.childPlans.map((plan) => (
            <TopPlanElement
              key={plan.planId}
              plans={props.allPlans}
              data={plan}
              handleDelete={props.handleDelete}
              handleEdit={props.handleEdit}
              onDataUpdate={props.onDataUpdate}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ParentPlanGroup;
